import { useEffect, useState } from 'react';
import { useDateService, DATE_FORMAT } from 'framework/utils';
import { Dropdown, DropdownOption } from 'framework/form';
import { ComplianceDocumentNamesResponce, useComplianceRegistryService } from 'domain/shared/compliance';

const ComplianceDocumentDropdown = (props: any) => {
  const { getComplianceDocumentNames } = useComplianceRegistryService();
  const [options, setOptions] = useState<DropdownOption[]>([]);
  const { getToday } = useDateService();

  useEffect(() => {
    (async () => {
      const asOfDate = getToday().format(DATE_FORMAT.API_ONLY_DATE);
      const response = await getComplianceDocumentNames(asOfDate);
      const data = response.map((complianceDocument: ComplianceDocumentNamesResponce) => ({
        value: complianceDocument.type,
        label: complianceDocument.type,
      }));
      setOptions(data);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Dropdown {...props} placeholder="Select document" options={options} />;
};

export default ComplianceDocumentDropdown;
